import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { PageRoute } from '../../types/page.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type CompanyReactivateResponse =
  | {
      clientSecret: null | string;
      hostedInvoiceUrl: null | string;
      requiresPayment: true;
    }
  | { requiresPayment: false };

export const useReactivate = () => {
  const navigate = useNavigate();

  const { mutate: reactivate, isPending } = useAppMutation<
    CompanyReactivateResponse,
    HttpException,
    { companyId: string }
  >([QueryKey.REACTIVATE_COMPANY], {
    defaultErrorHandling: false,
    onSuccess: (data, { companyId }) => {
      if (!data.requiresPayment) return;
      navigate(`${PageRoute.BILLING}/${companyId}`, {
        state: {
          billingPayment: {
            clientSecret: data.clientSecret,
            hostedInvoiceUrl: data.hostedInvoiceUrl,
          },
        },
      });
    },
    onError: (error) => {
      if (!(error instanceof HttpException)) return;
      toast.error(error.body?.message ?? error.message);
    },
    mutationFn: ({ companyId }: { companyId: string }) =>
      ApiService.patch<CompanyReactivateResponse, undefined>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'reactivate'],
      }),
  });

  return { reactivate, isPending };
};
